import { createFileRoute } from '@tanstack/react-router'
import ConceptContainer from 'Concept/containers/ConceptContainer'
import { conceptQueries } from 'Concept/utils/queries'
import { claimTypesEnum } from 'User/utils/claims'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from '../-guard'
import { prefetchWhenAuthenticated } from '../-prefetch'

export const Route = createFileRoute('/concept/$conceptId')({
    loader: ({ context, params }) =>
        prefetchWhenAuthenticated(
            context.queryClient,
            conceptQueries.detail(Number(params.conceptId)),
        ),
    pendingComponent: () => <PageSkeleton variant="detail" />,
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_concept]}>
            <ConceptContainer />
        </Guard>
    ),
})
